import { h } from 'preact'
import { useContext } from 'preact/hooks'
import { DriveI18nContext } from './drive-context.js'

/** Desktop uploader / folder-creator cell: avatar + name, or unknown. */
export function UploaderCell({ person }) {
  const i18n = useContext(DriveI18nContext)
  const t = (key) => (i18n ? i18n.t(key) : key)

  if (!person || !person.name) {
    return (
      <td class="d-none d-md-table-cell align-middle">
        <small class="text-muted">{t('drive.unknown')}</small>
      </td>
    )
  }

  return (
    <td class="d-none d-md-table-cell align-middle">
      <span class="drive-uploader" title={person.name}>
        {person.avatar_url ? (
          <img
            src={person.avatar_url}
            alt=""
            class="drive-uploader__avatar rounded-circle"
            width="24"
            height="24"
            loading="lazy"
          />
        ) : (
          <span class="drive-uploader__avatar drive-uploader__avatar--placeholder rounded-circle">
            <i class="bi bi-person-fill" aria-hidden="true"></i>
          </span>
        )}
        <small class="text-muted text-truncate">{person.name}</small>
      </span>
    </td>
  )
}
